import React, { ReactNode } from 'react';

import cx from 'clsx';

import styles from './Helper.module.scss';

type HelperProps = {
  helper?: ReactNode;
  className?: string;
  wrapperClassName?: string;
};
export const Helper = ({ helper, className, wrapperClassName }: HelperProps) =>
  helper ? (
    <div className={cx(styles['helper-wrapper'], wrapperClassName)}>
      <div className={cx(styles.helper, className)}>{helper}</div>
    </div>
  ) : null;
